import { ThemesDataResolver } from '@b2b/common/resolvers';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { CustomersIndividualsListControllerModule } from './controllers/CustomersIndividualsListController';

export const CustomersIndividualsListView = angular
  .module('acme.view.application.customers.individuals.list', [
    uiRouter,
    'ui.bootstrap',
    CustomersIndividualsListControllerModule,
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const customersIndividualsList = {
      name: 'application.customers.individuals.list',
      url: '/list',
      views: {
        'subview-main': {
          controller: 'CustomersIndividualsListController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/customers/individuals/list/list.tpl.html',
        },
      },
      data: {
        pageTitle: 'Customers',
        permissions: ['CUSTOMERS_VIEW'],
      },
      resolve: {
        ThemesData: ThemesDataResolver({ includeEmail: true }),
      },
    };

    $stateProvider.state(customersIndividualsList);
  }).name;
